import React from "react";
import { Button, Form, Modal, Spinner } from "react-bootstrap";
import {
  BsCheckLg,
  BsPencilSquare,
  BsQuestionLg,
  BsTrashFill,
  BsXLg,
} from "react-icons/bs";
import "./confirmAlert.css";

const ConfirmAlert = ({
  size,
  show = false,
  hide,
  children,
  deleteFunction,
  defaultIcon = <BsQuestionLg />,
  title = "Confirm Delete",
  description = "Are you sure you want to delete this!!",
  formikProps,
  type = "button",
   customClass, // 👈 add this
  // What is actually being confirmed. A bare "are you sure?" asks somebody to
  // approve money without showing them what they are approving — the row is
  // behind the dialog and the answer is irreversible. Pass
  // [{ label, value }]; falsy values are dropped so a record with nothing on
  // a field does not show a blank line.
  details = [],
  // Non-Formik callers pass their own in-flight flag. Without it the Confirm
  // button stayed clickable for the whole round trip, so an impatient second
  // click sent the same approve/close twice.
  busy = false,
}) => {
  const isBusy = busy || formikProps?.isSubmitting;
  const shown = details?.filter?.(
    (d) => d && d.value !== "" && d.value != null,
  );
  // Most callers ask for "sm", which is 300px — fine for a one-line question,
  // too narrow for a label-and-value table, where it wraps every row onto two.
  // A dialog that is showing a record gets the default width instead.
  const effectiveSize = shown?.length && size === "sm" ? undefined : size;
  return (
    <Modal
      size={effectiveSize}
      show={show}
      onHide={() => hide(false)}
      scrollable={true}
      backdrop="static"
      centered
      // className="my-modal modal-area"
     className={`my-modal modal-area ${customClass || ""}`} 
    dialogClassName={`custom-confirm-dialog ${customClass || ""}`} 
    contentClassName="custom-confirm-content"
    >
      <Form onSubmit={formikProps?.handleSubmit} className="d-content ">
        <Modal.Body className="d-grid gap-3 pb-0 text-center ">
          <div>
            <div
              className={`border-4 rounded-circle d-inline-flex p-3 fs-2 border ${
                title == "Confirm Delete" ||
                title === "Confirm Remove" ||
                title == "Confirm Reject"
                  ? "border-danger text-danger"
                  : title == "Confirm Approve"
                  ? "border-success text-success"
                  : "border-orange text-orange"
              }`}
            >
              {title === "Confirm Delete" ? (
                <BsTrashFill />
              ) : title === "Confirm Reject" || title === "Confirm Remove" ? (
                <BsXLg />
              ) : title === "Confirm Approve" ? (
                <BsCheckLg />
              ) : title === "Confirm Update" ? (
                <BsPencilSquare />
              ) : (
                defaultIcon
              )}
            </div>
          </div>
          <h4 className="fw-bolder my-0">{title}</h4>
          <p className="mb-0">{description}</p>
          {/* The record itself, left-aligned inside the centred dialog —
              labels read down one column so figures line up and can be checked
              at a glance. */}
          {shown?.length > 0 && (
            <div className="confirm-details text-start mx-auto">
              <table className="table-sm table mb-0">
                <tbody>
                  {shown.map((d, i) => (
                    <tr key={i}>
                      <th className="text-nowrap fw-semibold">{d.label}</th>
                      <td className={d.strong ? "fw-bold" : undefined}>
                        {d.value}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          {children}
        </Modal.Body>
        <Modal.Footer className="border-0 mt-0 flex-nowrap justify-content-center">
          <Button
            className="w-100"
            variant="outline-danger"
            onClick={() => hide(false)}
            disabled={isBusy}
          >
            Cancel
          </Button>
          <Button
            variant={`${
              title === "Confirm Delete" ||
              title === "Confirm Reject" ||
              title === "Confirm Approve" ||
              title === "Confirm Remove"
                ? "success"
                : "warning"
            }`}
            className={`w-100`}
            disabled={isBusy}
            onClick={deleteFunction}
            type={type}
          >
            {isBusy ? (
              <>
                <Spinner animation="border" variant="primary" size="sm" />{" "}
                PLEASE WAIT...
              </>
            ) : (
              "Confirm"
            )}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default ConfirmAlert;
